import { FormEvent } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import FormField from '@/shared/components/FormField';
import FormInput from '@/shared/components/FormInput';
import Button from '@/shared/components/Button';

interface Props {
  email: string;
  isLoading: boolean;
  isSuccess: boolean;
  onEmailChange: (value: string) => void;
  onSubmit: (event: FormEvent) => void;
}

export default function EmailVerificationResendForm({
  email,
  isLoading,
  isSuccess,
  onEmailChange,
  onSubmit,
}: Props) {
  const intl = useIntl();

  if (isSuccess) {
    return (
      <p className="text-sm text-slate-700">
        <FormattedMessage id="auth.emailVerificationConfirm.resendSuccess" />
      </p>
    );
  }

  return (
    <form className="space-y-4" onSubmit={onSubmit}>
      <FormField id="resend-email" labelId="auth.emailVerificationConfirm.resendEmailLabel">
        <FormInput
          id="resend-email"
          type="email"
          autoComplete="email"
          required
          placeholder={intl.formatMessage({ id: 'auth.emailVerificationConfirm.resendEmailPlaceholder' })}
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
        />
      </FormField>

      <Button type="submit" fullWidth disabled={isLoading}>
        {isLoading ? (
          <FormattedMessage id="auth.emailVerificationConfirm.resending" />
        ) : (
          <FormattedMessage id="auth.emailVerificationConfirm.resend" />
        )}
      </Button>
    </form>
  );
}
